<template>
  <Teleport to="body">
    <ProductPopupRenderer />
    <ContentDownloader />
  </Teleport>

  <RouterView />
</template>

<script setup lang="ts">
import ProductPopupRenderer from '@menu/Shared/ProductPopupRenderer.vue';
import ContentDownloader from '@menu/Shared/ContentDownloader.vue';
</script>
